export const additionalItem = {
  additionalItem: '增项',
  additionalItemDetail: '增项详情',
  noConfirmationNeeded: '无需确认',
  toBeSigned: '待签名',
  toBeConfirmed: '待确认',
  signed: '已签名',
  confirmed: '已确认',
  notPassed: '未通过',
  thisRecordHasBeenDeleted: '此款项记录已被删除',
  pleaseSignFirst: '请先签名',
  notPass: '不通过',
  pass: '通过',
  constructionProject: '施工项目',
  cost: '费用',
  ownerSignature: '业主签名',
  confirmationTime: '确认时间',
  reason: '原因',
  clickHereToSign: '点击此处签名',
  addAdditionalItem: '添加增项',
  editAdditionalItem: '编辑增项',
  signatureRequired: '需签名',
  confirmationRequired: '需确认',
  pleaseEnterAdditionalItemCost: '请输入增项费用',
  pleaseSelectAdjustmentReason: '请选择调整原因',
  ownerConfirmation: '业主确认',
  additionalItemCost: '增项费用',
  adjustmentReason: '调整原因',
  extraItemRecords: '增项记录',
  waitingForOwnerSignature: '待业主签名',
  waitingForOwnerConfirmation: '待业主确认',
  addDate: '添加日期'
};
